// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-eye.svg';

export const MindBodyEye = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
